module.exports = __webpack_public_path__ + "img/adbaits.227f5851.webp";